var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 574,
    height: 600,
    viewBox: "0 0 574 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_184_239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.889 0.413656V6.08902C263.889 40.3728 263.889 74.6567 264.005 108.94C264.005 113.06 263.113 114.947 258.753 116.055C248.003 118.819 237.451 122.376 226.354 125.751V46.8755C141.523 69.1468 44.0091 154.823 37.6679 287.193C31.0624 425.238 126.396 525.906 226.238 553.819V547.201C226.238 423.17 226.21 299.145 226.155 175.125C226.155 170.592 227.41 168.027 231.506 166.356C241.909 162.12 252.247 157.702 263.757 152.887V288.566C265.904 287.954 267.341 287.656 268.711 287.144C280.733 282.461 292.656 277.547 304.761 273.112C308.757 271.64 309.83 269.505 309.83 265.418C309.731 179.521 309.731 93.6297 309.83 7.74364V0C370.27 8.1573 423.114 31.4379 468.725 70.7848C511.76 107.898 555.274 175.341 560.145 212.04L525.665 225.608C508.044 168.391 475.777 122.029 428.118 86.6196C403.709 68.5214 376.322 54.8513 347.201 46.2302V53.494C347.201 177.348 347.261 301.202 347.382 425.057C347.382 430.02 346.061 432.817 341.504 434.571C332.751 437.88 324.098 441.636 315.362 445.111C313.534 445.672 311.669 446.109 309.781 446.418V311.897C307.469 312.625 305.851 313.055 304.315 313.651C292.623 318.217 281.047 323.065 269.24 327.318C264.979 328.84 263.922 331.09 263.922 335.359C264.054 421.069 264.098 506.784 264.054 592.504C264.054 594.92 264.054 597.319 264.054 599.768C151.117 590.353 16.3487 491.771 1.48633 329.121C-15.0934 149.892 119.592 16.1657 263.889 0.413656Z",
    fill: "url(#paint0_linear_184_239)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.665 600V593.812C309.665 560.057 309.781 526.287 309.583 492.532C309.583 487.568 310.772 485.483 315.924 484.094C388.27 464.635 434.525 418.488 454.87 346.363C459.544 329.816 460.931 312.708 460.848 295.483C460.848 293.828 461.806 291.115 463.044 290.519C474.092 285.853 485.305 281.568 498.07 276.537C498.07 288.897 498.615 300.347 497.987 311.731C495.246 361.238 478.468 405.449 447.125 443.919C422.298 474.678 389.722 498.236 352.766 512.156C348.489 513.811 346.953 515.763 347.118 520.429C347.514 531.399 347.25 542.386 347.25 554.299C354.269 551.867 360.626 550.063 366.67 547.532C458.8 508.963 514.468 440.593 532.782 342.16C537.178 318.38 537.669 294.04 534.235 270.101C533.393 264.144 534.896 261.464 540.642 259.594C550.204 256.483 559.468 252.413 568.914 248.723C601.099 416.965 476.619 582.808 309.665 600Z",
    fill: "url(#paint1_linear_184_239)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.479 104.688C428.944 127.307 474.208 178.981 489.863 239.573C484.198 241.856 478.485 244.19 472.721 246.473C457.644 252.413 442.6 258.419 427.457 264.144C424.006 265.451 422.834 267.106 422.751 270.895C422.338 288.682 422.751 306.619 420.571 324.224C417.268 351.707 405.379 375.947 387.692 397.242C386.992 397.992 386.254 398.704 385.479 399.377V104.688ZM424.485 188.197L423.279 188.909V225.31L442.32 217.682C436.061 207.341 430.265 197.777 424.485 188.197V188.197Z",
    fill: "url(#paint2_linear_184_239)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.789 424.742C42.4732 319.343 74.3117 169.268 187.893 104.589C188.025 106.061 188.256 107.335 188.256 108.61C188.256 120.672 188.438 132.751 188.141 144.813C187.982 147.283 186.875 149.595 185.053 151.266C150.374 179.245 127.255 214.654 117.842 258.221C114.653 274.307 113.028 290.665 112.987 307.065C112.293 343.963 112.772 380.878 112.789 417.776V424.742Z",
    fill: "url(#paint3_linear_184_239)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.605 496.9C175.359 488.379 164.031 479.99 153 471.221C151.497 470.029 150.82 467.001 150.82 464.834C150.765 420.788 150.803 376.703 150.935 332.58C150.935 316.513 150.688 300.381 151.992 284.397C154.519 253.555 166.673 226.485 186.423 202.758C186.931 202.305 187.485 201.906 188.075 201.566V495.759L186.605 496.9Z",
    fill: "url(#paint4_linear_184_239)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_184_239",
    x1: 80.6365,
    y1: 93.9496,
    x2: 425.427,
    y2: 438.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005E7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#005D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#004270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#002F67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#002462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002060"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_184_239",
    x1: 384.324,
    y1: 369.312,
    x2: 507.46,
    y2: 492.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005E7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#005D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#004270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#002F67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#002462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002060"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_184_239",
    x1: 314.817,
    y1: 175.49,
    x2: 462.228,
    y2: 322.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005E7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#005D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#004270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#002F67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#002462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002060"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_184_239",
    x1: 83.6419,
    y1: 197.843,
    x2: 211.693,
    y2: 325.626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005E7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#005D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#004270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#002F67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#002462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002060"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_184_239",
    x1: 111.781,
    y1: 277.596,
    x2: 259.043,
    y2: 424.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005E7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#005D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#004270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#002F67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#002462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002060"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_184_239"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 574,
    height: 600,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.57a09b86fb196142d25ae7ba6bb4b55b.svg";
export { ForwardRef as ReactComponent };